import { FC, useMemo } from 'react';
import {
  OptionalMenu,
  IMenuItem,
} from '../../../../../../../../shared/components/optionalMenu/optionalMenu.tsx';
import { useTranslation } from 'react-i18next';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import PictureInPictureOutlinedIcon from '@mui/icons-material/PictureInPictureOutlined';
import { Theme } from '../../../../../../../../shared/styles/theme/theme.ts';
import { GeneralSettingsPopup, PopupType } from './popups/generalSettings.popup.tsx';

export const CommonMenu: FC = () => {
  const { t } = useTranslation();
  const generalSettingsPopup = useMemo(() => new GeneralSettingsPopup(), []);
  const menuItems: IMenuItem[] = [
    {
      label: t('settings.letterhead'),
      icon: <EditNoteOutlinedIcon />,
      onClick: () =>
        generalSettingsPopup.stream.emit('open', {
          popupType: PopupType.HEADER_TEXT,
        }),
      color: Theme.palette.primary.main,
    },
    {
      label: t('settings.logo'),
      icon: <PictureInPictureOutlinedIcon />,
      onClick: () => generalSettingsPopup.stream.emit('open', { popupType: PopupType.LOGO }),
      color: Theme.palette.success.light,
    },
    {
      label: t('settings.footerText'),
      icon: <EditNoteOutlinedIcon />,
      onClick: () =>
        generalSettingsPopup.stream.emit('open', {
          popupType: PopupType.FOOTER_TEXT,
        }),
      color: Theme.palette.purple.main,
    },
  ];
  return (
    <>
      <OptionalMenu {...{ menuItems, title: t('settings.general_settings_for_all_print_forms') }} />
      <generalSettingsPopup.Component />
    </>
  );
};
